<script lang="ts">
  import { selectedText, userSignedIn, userData } from "../store";
  import { trackButtonClick } from "../utils";
  const synonymAPI = "https://api.datamuse.com/words?";
  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();

  //   const synonymAPI = process.env.SYNONYM_API;
  //   SYNONYM_API="https://api.datamuse.com/words?rel_syn="
  let overlayText = "Please sign in!";
  async function handleClick() {
    if (!$userSignedIn) {
      return;
    }
    const synButton = document.getElementById("synButton");
    synButton.innerHTML = "";

    const loadingText = document.createElement("div");
    loadingText.setAttribute("class", "loading-text");
    loadingText.innerText = "Loading...";
    synButton.appendChild(loadingText);
    trackButtonClick("Synonym", 1);
    synonym();
  }
  async function synonym() {
    const synonymAsync = async () => {
      try {
        const textArea = document.getElementById("input-textarea");
        $selectedText = textArea.value.substring(
          textArea.selectionStart,
          textArea.selectionEnd,
        );
        try {
          const syn = await fetch(
            synonymAPI + "rel_syn=" + $selectedText + "&max=3",
          );
          const spc = await fetch(
            synonymAPI + "rel_spc=" + $selectedText + "&max=3",
          );
          if (!syn.ok) {
            throw new Error("Request failed");
          }
          if (!spc.ok) {
            throw new Error("Request failed");
          }
          const synData = await syn.json();
          const synDataFinal = synData.map((item) => item.word);
          const spcData = await spc.json();
          const spcDataFinal = spcData.map((item) => item.word);
          const responseData = synDataFinal.concat(spcDataFinal);
          if (responseData.length == 0) {
            responseData.push("No synonyms found!");
          }

          dispatch("success", responseData);
          document.getElementById("synButton").innerHTML = "Success!";
          setTimeout(() => {
            document.getElementById("synButton").innerHTML = "Synonym";
          }, 2000);
        } catch (error) {
          console.error(error);
          document.getElementById("synButton").innerHTML = "Synonym";
        }
        // Reset button to original state
      } catch (error) {
        console.error(error);
        document.getElementById("synButton").innerHTML = "Synonym";
      }
    };
    setTimeout(synonymAsync, 250);
  }
  $: userSignedIn.subscribe((value) => {
    if (value) {
      if ($selectedText.length == 0) {
        overlayText = "Please highlight text!";
        return;
      } else {
        overlayText = "";
      }
    } else {
      if ($userData.premium || $userData.admin) {
        overlayText = "";
      } else {
        overlayText = "Please sign in!";
      }
    }
  });
</script>

<div class="button-container">
  <button
    id="synButton"
    class="button synButton active-button"
    on:click={handleClick}
    class:grey-overlay={!$userSignedIn || $selectedText.length == 0}
  >
    Synonym
  </button>
  <div class="overlay-text">{overlayText}</div>
</div>